import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { ContactIcon, PhoneInfoPopoverWrapper, PhoneNumber, PhoneNumberWrapperSection } from "./InfolinePopover.styles";
import { useSiteInfo } from "../../SiteInfo";
import { Runtime } from "../..";
var HIDE_PHONE_NUMBER_FOR_BRAND = {
    floyt: false,
    "billiger-mietwagen": true,
    carigami: false
};
var InfolinePopover = function(param) {
    var popupContent = param.popupContent;
    var ref = useSiteInfo(), _settings = ref.settings, phoneNumber = _settings.phoneNumber, language = _settings.language;
    var isHomepage = Runtime.usePath().isHomepage;
    var brandName = Runtime.useBrand().brandName;
    var hidePhoneNumber = isHomepage || HIDE_PHONE_NUMBER_FOR_BRAND[brandName];
    return /*#__PURE__*/ _jsx(PhoneInfoPopoverWrapper, {
        children: /*#__PURE__*/ _jsx(Ui.Popover, {
            button: {
                as: "div",
                children: /*#__PURE__*/ _jsx(PhoneNumberWrapperSection, {
                    children: /*#__PURE__*/ _jsx(PhoneNumber, {
                        phoneNumber: hidePhoneNumber ? "" : phoneNumber,
                        language: language,
                        icon: /*#__PURE__*/ _jsx(ContactIcon, {})
                    })
                })
            },
            triggerAction: "click",
            children: /*#__PURE__*/ _jsx(Ui.PopoverPanel, {
                children: /*#__PURE__*/ _jsx(Ui.PanelContentWrapper, {
                    width: "14rem",
                    widthMd: "21.875rem",
                    padding: "1.5rem 0 0 0",
                    children: popupContent
                })
            })
        })
    });
};
export { InfolinePopover as InfolinePopoverButton };
